import React from 'react';
import styled from 'styled-components';

const AVATAR_SIZE = 40;

const StyledAvatarRing = styled.div`
  display: flex;
  flex-shrink: 0;
  padding: 2px;
`;

const StyledAvatar = styled.div`
  position: relative;
`;

const AvatarPlaceholder = styled.div`
  width: ${AVATAR_SIZE}px;
  height: ${AVATAR_SIZE}px;
  border-radius: 50%;
  background-color: ${({ theme }: any) => theme.colors.primary['100']};
`;

const StyledInitials = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }: any) => theme.colors.primary['0']};
  font-size: 16px;
  font-weight: ${({ theme }: any) => theme.fontWeights.bold};
  white-space: nowrap;
`;

interface UserAvatarProps {
  initials: string;
}

const UserAvatar = ({ initials }: UserAvatarProps) => (
  <StyledAvatarRing data-testid="top-bar-avatar">
    <StyledAvatar>
      <AvatarPlaceholder aria-hidden="true" />
      <StyledInitials>{initials}</StyledInitials>
    </StyledAvatar>
  </StyledAvatarRing>
);

export default UserAvatar;
